import moment from "moment";
import { calcularFechas } from "../../../components/credits/calculoFechas";
import { calcDescuentoFirmaElectronicaV1 } from "../../../utils/creditUser/calcDctoFirmaElectronica";
import { convertToNumber } from "../../../utils/isValidNumber";
import { CreditsService } from "../../../services/credits/credits.service";
import { calcInteresCorrienteV2 } from "../../../utils/creditUser/calcInteresCorriente";
import { FunnelService } from "../../../services/funnel/funnel.service";

export const validateCreditDatesFromViewOffer = async (credit) => {
  let isChanges = false;
  let now = moment();
  let approvedDate = moment(credit?.approvedDate, "DD/MM/YYYY");
  let paydayLimit = moment(credit?.paydayLimit, "DD/MM/YYYY");

  if (
    approvedDate.format("DD/MM/YYYY") !== now.format("DD/MM/YYYY") ||
    paydayLimit.isBefore(now, "day")
  ) {
    const fechasOptions = calcularFechas();
    const dateLimit2 = fechasOptions.fecha2.format("DD/MM/YYYY");
    const vence2 = fechasOptions.fecha2.diff(moment(), "days") + 1;

    let totalToPay = calculateTotal(
      convertToNumber(credit?.approvedQuota),
      vence2,
    );
    let newCredit = {
      termInDays: vence2,
      totalToPay: totalToPay,
      paydayLimit: dateLimit2,
      approvedDate: now.format("DD/MM/YYYY"),
      versionTarifas: "2",
      versionContrato: "2",
    };
    try {
      // Actualizamos en DB
      await updateCreditChangesFromViewOffer(
        newCredit,
        credit?.credit_id,
        credit?.documento,
      );
      // Retornamos los cambios para que el componente React los use
      return { isChanges: true, creditChanges: newCredit };
    } catch (error) {
      console.error("Error actualizando fechas:", error);
    }
  }
  return { isChanges, creditChanges: null };
};

export const updateCreditContextFromViewOffer = (data, updateCreditUser) => {
  return updateCreditUser({
    credit_id: data?.credit_id,
    approvedQuota: data?.approvedQuota,
    termInDays: data?.termInDays,
    totalToPay: data?.totalToPay,
    paydayLimit: data?.paydayLimit,
    documento: data?.documento,
    approvedDate: data?.approvedDate,
    versionTarifas: "2",
    versionContrato: "2",
  });
};

export const updateMyBanksContextFromViewOffer = (
  infoUser,
  updateMyBanks,
  myBanks,
) => {
  let myBankAccounts = infoUser?.myBankAccounts;
  let newMyBanks = { ...myBanks };
  newMyBanks.myBankAccounts = myBankAccounts;
  return updateMyBanks(newMyBanks);
};

export const setDataToLocalStorage = (data) => {
  localStorage.setItem("token", data?.otp);
  localStorage.setItem("token_jwt", data?.tokenJwt);
  localStorage.setItem("credit_id", data?.creditId);
  localStorage.setItem("doc", data?.documento);
  localStorage.setItem("type_user", data?.typeUser);
  localStorage.setItem("is_signin", data?.isSignin);
  localStorage.setItem("idOperation", data?.idOperation);
  return;
};

const updateCreditChangesFromViewOffer = async (
  creditChanges,
  creditId,
  documento,
) => {
  try {
    await CreditsService.updateCreditFromOfferPage({
      credit: creditChanges,
      creditId: creditId,
      documento: documento,
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

const calculateTotal = (amount, vencimientoEnDias) => {
  let total =
    amount +
    calculateInterest(amount, vencimientoEnDias) +
    calcDescuentoFirmaElectronicaV1(amount, vencimientoEnDias);
  return total;
};

const calculateInterest = (amount, vencimientoEnDias) => {
  let tasa = localStorage.getItem("currentInterestRate");
  const interest2 = calcInteresCorrienteV2(amount, vencimientoEnDias, tasa);
  return interest2;
};

export const handleAddTimeline = async (
  creditId,
  payloadTimeline,
  idOperation = null,
) => {
  try {
    if (idOperation) {
      await FunnelService.addTimelineByOperationId(
        idOperation,
        payloadTimeline,
      );
    } else {
      await FunnelService.addTimelineByCreditId(creditId, payloadTimeline);
    }
  } catch (error) {
    console.error("Error guardando timeline:", error);
  }
};